<template>
  <div class="sequence-list-section">
    <div v-if="!loading">
      <div v-if="sequenceList && sequenceList.length > 0">
        <ul class="menuList btm-line">
          <li
            v-for="(ele, index) in sequenceList"
            :key="index"
            @click.stop="selectSequence(ele)"
          >
            <span class="text">{{ ele.name }}</span>
            <span class="owner-tag">{{ getInitial(ele.owner) }}</span>
          </li>
        </ul>
      </div>
      <div v-else class="no-seq">
        <img src="@/assets/images/no_sequences.jpg" />
        <div v-if="shared">
          <p class="text">
            You don't have <br />
            any shared sequence
          </p>
        </div>
        <div v-else>
          <p class="text">
            You don't have any sequences <br />
            in this folder
          </p>
          <div class="btnSection">
            <V-Button
              :className="'btn-blue'"
              :text="'Create a Sequence'"
              :callback="redirectToSalesgearSeq"
            ></V-Button>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="menu-load-list">
      <ul class="menuList d-content">
        <li v-for="index in 5" :key="index">
          <span class="text w-90 linear-background"></span>
          <span class="owner-tag w-10 linear-background"></span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import { postFromCustomUrl } from '@/assets/util/rest.js'
import { SALESGEAR_URL } from '@/assets/util/constants/constants'
import shareFunction from '@/assets/util/functions'
import { MxEvent } from '@/assets/util/constants/analytics'
import ButtonVue from '@/components/Button'

export default {
  name: 'SequenceList',
  props: ['sequenceList', 'loading', 'shared', 'folderObj'],
  data: function() {
    return {}
  },
  methods: {
    selectSequence(obj) {
      this.$parent.$emit('addContactToSequence', obj)
      //do sequence selected action
      //emit
    },
    getInitial(owner) {
      if (owner) {
        const fn = owner.firstName
        const ln = owner.lastName
        if (fn && ln) {
          return fn[0] + ln[0]
        } else if (fn) {
          return fn.slice(0, 2)
        } else if (ln) {
          return ln.slice(0, 2)
        }
      }
    },
    redirectToSalesgearSeq() {
      shareFunction.track(
        MxEvent.aeCreateSeqClicked,
        { pageType: this.pageType },
        this.$store.state
      )
      this.$store.state.salesgear.isContactLimit = false
      const url = this.constructFolderUrl()
      window.open(url, '_blank')
    },
    constructFolderUrl() {
      if (this.folderObj && this.folderObj.id) {
        return `${SALESGEAR_URL}/sequences/${this.folderObj.id}`
      } else {
        return `${SALESGEAR_URL}/sequences/all`
      }
    },
    mxShownCreateSeq() {
      shareFunction.track(
        MxEvent.aeCreateSeqShown,
        { pageType: this.pageType },
        this.$store.state
      )
    }
  },
  components: {
    'V-Button': ButtonVue
  }
}
</script>

<style lang="scss" scoped>
.sequence-list-section {
  .owner-tag {
    letter-spacing: 0.4px;
    background-color: $border-medium;
    padding: 0 5px;
    font-size: 11px;
    will-change: font-size;
    color: $text-dark;
    font-weight: 600;
    border-radius: 3px;
    margin-left: 5px;
    text-transform: uppercase;
  }
  .btm-line li {
    &:not(:last-child) {
      border-bottom: 1px solid $bg-medium !important;
    }
    &:hover:not(:last-child) {
      border-bottom: 1px solid transparent !important;
    }
  }
  .no-seq {
    padding: 10px;
    text-align: center;
    img {
      pointer-events: none;
      position: relative !important;
      display: block;
      width: 100% !important;
      height: 100% !important;
      padding: 15px;
    }
    .text {
      @include relBlock;
      letter-spacing: 0.3px;
      text-align: center;
      color: $text-dark;
      margin: 0;
      font-size: 14px;
    }
    .btnSection::v-deep {
      margin: 15px 0;
      .btn-blue {
        padding: 10px 15px;
        font-size: 14px;
        letter-spacing: 0.3px;
      }
    }
  }
}
</style>
